import {TweenMax} from 'gsap';



function init() {
    if (this._initiated) return;

    this.el.style.pointerEvents = 'none';
    this._initiated = true;

    return this;
}

function show() {
    this.el.classList.remove('deactivate');

    TweenMax.killDelayedCallsTo(_show);
    TweenMax.killDelayedCallsTo(_show2);
    TweenMax.killDelayedCallsTo(_shown);
    TweenMax.delayedCall(0.01, _show, [], this);

    return this;
}

function _show() {
    this.el.classList.remove('deactivate');
    this.el.classList.add('activate');

    TweenMax.killDelayedCallsTo(_show2);
    TweenMax.killDelayedCallsTo(_shown);
    TweenMax.delayedCall(1.6, _show2, [], this);

    return this;
}

const _show2 = function () {
    this.el.classList.remove('deactivate');
    this.el.classList.add('active');
    TweenMax.killDelayedCallsTo(_shown);
    TweenMax.delayedCall(0.01, _shown, [], this);
};

const _shown = function () {
    this.el.classList.remove('deactivate');
    this.el.classList.remove('activate');
};

function hide() {
    TweenMax.killDelayedCallsTo(_shown);
    this.el.classList.remove('activate');
    this.el.classList.remove('active');
    this.el.classList.add('deactivate');
    return this;
}

function destroy() {

    return this;
}

function enable() {
    if (!this._initiated) return;
    this.el.style.pointerEvents = 'all';
    return this;
}

function disable() {
    if (!this._initiated) return;
    this.el.style.pointerEvents = 'none';
    return this;
}

module.exports = el => {
    const Controller = {
        el: el
    };

    Controller.init = init.bind(Controller);
    Controller.enable = enable.bind(Controller);
    Controller.disable = disable.bind(Controller);
    Controller.show = show.bind(Controller);
    Controller.hide = hide.bind(Controller);
    Controller.destroy = destroy.bind(Controller);

    return Controller;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/DefaultSectionController.js